module.exports = __webpack_public_path__ + "img/temoignage-2-rounded.471b4eed.jpg";